module.exports = __webpack_public_path__ + "img/logo_dark.f206b4a0.svg";